import React, { useState } from 'react'
import {Form} from 'react-bootstrap';
import EventToast from "../../components/EventToast"
import AsyncSelect from 'react-select/async';
import { components } from 'react-select';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import DefaultApi from "../../api/default"
import ViewsApi from "../../api/views"
import './style.css'

const Autocomplete = ({data, inputs, value, handleChange, formatLabel, disabled, lockupFields, resolver, objectType, filterOperators, setFilterOperators}) => {

	const [showToast, setShowToast] = useState(false);
	const [toastError, setToastError] = useState("");
	const [defaultOptions, setDefaultOptions] = useState([]);

	const customStyles = {
		control: (provided, state) => ({
			...provided,
			border: state.isFocused ? 'var(--bs-border-width) solid #66bb6a' : 'var(--bs-border-width) solid var(--bs-border-color)', // Cor da borda focada e não focada
			boxShadow: state.isFocused ? '0 0 0 0.25rem rgba(25,135,84,.25)' : 'none', // Remove a sombra
			backgroundColor: state.isDisabled ? 'var(--bs-secondary-bg)' : 'var(--bs-input-bg)', // Cor de fundo do input
			'&:hover': {}
		}),
		option: (provided, state) => ({
			...provided,
			backgroundColor: state.isSelected ? '#198754' : '#fff', // Cor de fundo da opção selecionada e não selecionada
			color: state.isSelected ? '#fff' : '#000', // Cor do text da opção selecionada e não selecionada
			'&:hover': {}
		})
	};

	const getOperatorForField = () => {
		return (filterOperators && filterOperators[data.nameForm]) || 'contains';
	}

	const applyOperator = (raw) => {
		const op = getOperatorForField();
		if (op === 'eq') return raw;
		if (op === 'starts') return `${raw}%`;
		if (op === 'ends') return `%${raw}`;
		// contains
		return `%${raw}%`;
	}

	const promiseOptions = (inputValue) =>
  	new Promise((resolve) => {
			var filters = {}

			if (typeof inputValue === 'string') {
				filters[data.nameForm] = applyOperator(inputValue)
			}

			let dataFilters = { ...data.params?.filters } // Cria uma cópia do objeto filters para não alterar o original

			for (const index in dataFilters) {
				let filter = dataFilters[index]
				let value = filter.value

				if (typeof value === 'string' && value.startsWith('{{') && value.endsWith('}}')) {
					const inputName = value.replace('{{', '').replace('}}', '')
					// Resolve in order: inputs -> resolver (central) -> lockupFields -> empty
					value = inputs[inputName]?.value || inputs[inputName] || (resolver ? resolver(inputName) : undefined) || lockupFields?.[inputName] || ""
				}

				filters[filter.field] = value
			}

			// filtros construídos para a chamada à API

			if (data.entity === "views") {

				ViewsApi.getAll({params: { ...filters, pageSize: 10}})
				.then(response => {
					resolve(response.data.map(d => {return {
						value: d,
						label: d[data.nameForm],
						field: data.params.key,
						fields: data.fields
					}}).sort())
				}).catch(error => {
					setShowToast(true)
					setToastError(`${error?.response?.data?.message} (${error.response?.status})`)
				})

			} else {

				DefaultApi.get(data.entity, {
					params: { ...filters, pageSize: data.pageSize || 10 }
				})
				.then(response => {
					resolve(response.data.data.map(d => {return {
						value: d[data.params.sourceKey],
						label: d[data.nameForm],
						field: data.params.key,
						data: d,
						fields: data.fields
					}}).sort())
				}).catch(error => {
					setShowToast(true)
					setToastError(`${error?.response?.data?.message} (${error.response?.status})`)
				})

			}

  });

	// Carrega opções padrão quando componente monta
	React.useEffect(() => {
		if (data.loadOnFocus) return; // Se loadOnFocus está ativo, não carrega inicial
		
		// Carrega as opções iniciais
		promiseOptions('').then(options => {
			setDefaultOptions(options || []);
		});
	}, []); // Carrega apenas na montagem (key force remount quando necessário)

	const CustomIndicatorsContainer = (props) => {
		const [copied, setCopied] = useState(false);
		const hasValue = props.selectProps.value && props.selectProps.value.label;
		
		return (
			<div style={{ display: 'flex', alignItems: 'center' }}>
				{hasValue && (
					<>
						<CopyToClipboard text={props.selectProps.value.label} onCopy={() => setCopied(true)}>
							<div
								className="indicator-custom"
								style={{
									color: copied ? 'green' : 'hsl(0, 0%, 80%)',
								}}
							>
								<i className={`bi bi-clipboard${copied ? '-check' : ''}`}></i>
							</div>
						</CopyToClipboard>
						<span className="indicator-separator" />
					</>
				)}
				<components.IndicatorsContainer {...props} />
			</div>
		);
	};
	
	return (
		<Form.Group className={data.class} controlId={data.nameForm}>
			<Form.Label>{data.name}</Form.Label>
			<AsyncSelect
				id={'autocomplete-' + data.nameForm}
				isMulti={data.multiple}
				value={value}
				cacheOptions={false}
				defaultOptions={defaultOptions}
				loadOptions={promiseOptions}
				onFocus={e => data.loadOnFocus ? promiseOptions(e) : null}
				placeholder={data.placeholder}
				isDisabled={disabled}
				required={data.required}
				isClearable={true}
				clearValueLabel="Limpar seleção"
				noOptionsMessage={() => "Nenhuma opção encontrada"}
				styles={customStyles}
				name={data.nameForm}
				onChange={e => data.multiple ? handleChange({field: data.params.key, list: e}) :
					e !== null ? handleChange(e) : 
						handleChange({value: 0, label: "", field: data.params.key})}
				components={{ IndicatorsContainer: CustomIndicatorsContainer }}
			/>
			<EventToast
				show={showToast}
				setShow={setShowToast}
				message={`Erro ao carregar a tela: ${toastError}`}
			/>
		</Form.Group>
	)
}

export default Autocomplete